export enum FaultyActionTypes {
    API_RESPONSE_SUCCESS = '@@faulty/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@faulty/API_RESPONSE_ERROR',
    ADD_FAULTY_RECEIVED = '@@faulty/ADD_FAULTY_RECEIVED',
    UPD_FAULTY_SENT = '@@faulty/UPD_FAULTY_SENT',
    ADD_FAULTY_SENT = '@@faulty/ADD_FAULTY_SENT',
    ADD_FAULTY_DECLARE = '@@faulty/ADD_FAULTY_DECLARE',
    UPD_FAULTY_DECLARE = '@@faulty/UPD_FAULTY_DECLARE',
    UPD_FAULTY_RECEIVED_BACK = '@@faulty/UPD_FAULTY_RECEIVED_BACK',
    ADD_FAULTY_RECEIVED_BACK = '@@faulty/ADD_FAULTY_RECEIVED_BACK',
    UPD_FAULTY_RECEIVED = '@@faulty/UPD_FAULTY_RECEIVED',
    RESET = '@@faulty/RESET',
}